"use client"

import { GetPageQuery } from "apollo"
import { CustomBreadcrumbs, HomeIcon } from "ui"
import { BlockRenderer, findProperty } from "utils"
import MapComponentBlock from "../PazRealEstateCenter/MapComponentBlock"
import ContentText from "./ContentText"
import ImageText from "./ImageText"
import TopBanner from "./TopBanner"

type Props = {
  data: GetPageQuery
  parents: {
    url: string
    title: string
    name: string
    isPage: boolean
  }[]
}

const components = {
  topBanner: TopBanner,
  imageTextBlock: ImageText,
  contentText: ContentText,
  mapComponent: MapComponentBlock
}

export default function Dynamic({ data, parents }: Props) {
  return (
    <>
      {findProperty(data?.page, "blocks")?.blocks?.map(
        (block: any, index: number) => {
          return (
            <BlockRenderer
              index={index}
              key={index}
              blockType={block.blockType}
              blockData={block}
              components={components}
            >
              {block.blockType === "topBanner" && (
                <CustomBreadcrumbs
                  current={parents[parents.length - 1]}
                  parents={[
                    { title: <HomeIcon />, url: "/" },
                    ...parents.slice(0, -1),
                  ]}
                ></CustomBreadcrumbs>
              )}
            </BlockRenderer>
          )
        },
      )}
    </>
  )
}
